
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import VectorImage from 'components/VectorImage'
import WithTooltip from 'components/WithTooltip'

const convertPathToName = path => {
  return path
    .split('/')
    .filter(folder => folder !== '.')
    .map(item => item.replace(/\.svg$/, ''))
    .join('-')
}

function requireAll(requireContext) {
  return requireContext.keys().reduce((acc, key) => {
    acc[convertPathToName(key)] = requireContext(key)
    return acc
  }, {})
}

const icons = requireAll(require.context('./images', true, /^\.\/.*\.svg$/))

export default class Icon extends React.Component {
  static propTypes = {
    name: (props, propName) => {
      const name = props[propName]
      const haveIcon = Object.keys(icons).indexOf(name) !== -1
      if (!haveIcon) {
        return new Error('<Icon /> component called with icon (' + name + ') that does not exist')
      }
    },
    width: PropTypes.string,
    height: PropTypes.string,
    size: PropTypes.string,
    className: PropTypes.string,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onClick: PropTypes.func,
    align: PropTypes.oneOf(['left', 'right']),
    tooltipPlace: WithTooltip.propTypes.place,
    tooltipAlign: WithTooltip.propTypes.align,
    tooltipStyle: WithTooltip.propTypes.style
  }

  static defaultProps = {
    width: '16px',
    height: '16px',
    tooltipPlace: 'top',
    tooltipStyle: 'blue'
  }

  render() {
    const {
      tooltip,
      className,
      name,
      onClick,
      tooltipPlace,
      tooltipAlign,
      tooltipStyle
    } = this.props

    return (
      <WithTooltip place={tooltipPlace} style={tooltipStyle} align={tooltipAlign} title={tooltip}>
        <span
          className={classnames(className, 'icon', {[`icon-${name}`]: true})}
          onClick={onClick}
        >
          {this.renderIcon()}
        </span>
      </WithTooltip>
    )
  }

  renderIcon() {
    const {name, width, height, size, align} = this.props
    const source = icons[name]

    return (
      <VectorImage
        width={size || width}
        height={size || height}
        className='icon_image'
        source={source}
        align={align}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Icon/index.js